var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { ExperimentStates } from "@ane/exp-data/lib/models";
import NavigationService from "@ane/core/lib/services/NavigationService";
import { compareIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
import { navigateToExperiment } from "../../utils/ExperimentRoute.utils.js";
import { ROUTES } from "@ane/exp-data/lib/routes/Routes.constants";
class ExperimentUtils {
  constructor() {
    __publicField(this, "StartingState", "Starting");
    __publicField(this, "StoppingState", "Stopping");
    __publicField(this, "EventTypeOperationFailed", "Operation Failed");
    __publicField(this, "redirectEmergencyFlightShutdown", (experimentId) => {
      var _a;
      NavigationService.navigateTo(
        NavigationService.addParamsToPath({
          url: NavigationService.getCustomQueryParams(`${ROUTES.emergencyShutdown.location.pathname}`),
          queryParams: [
            {
              param: `${(_a = ROUTES.emergencyShutdown.match.params) == null ? void 0 : _a.experimentId}`,
              value: experimentId
            }
          ]
        })
      );
    });
    __publicField(this, "redirectToNewExperiment", (newExperimentId) => {
      navigateToExperiment(newExperimentId);
    });
  }
  getFriendlyState(experimentData) {
    if (!experimentData || !experimentData.state || !experimentData.state.FriendlyLabel) {
      return "";
    }
    return experimentData.state.FriendlyLabel;
  }
  getApplicableOperations(experimentData) {
    if (!experimentData || !experimentData.state || !experimentData.state.State) {
      return [];
    }
    switch (experimentData.state.State.toLowerCase()) {
      case ExperimentStates.NEW:
        return ["start"];
      case ExperimentStates.STARTING:
      case ExperimentStates.RUNNING:
        return ExperimentStates.canAdvance(experimentData.stages) ? ["advance", "stop"] : ["stop"];
      default:
        return [];
    }
  }
  isOperationError(experimentData, experimentJournalEntriesBackend) {
    if (!experimentJournalEntriesBackend || experimentJournalEntriesBackend.length === 0) {
      return false;
    }
    const currentState = this.getFriendlyState(experimentData);
    if (!currentState) {
      return false;
    }
    if (compareIgnoreCase(currentState, this.StartingState) || compareIgnoreCase(currentState, this.StoppingState)) {
      const latestJournalEntry = experimentJournalEntriesBackend[0];
      return latestJournalEntry.EventType === this.EventTypeOperationFailed;
    }
    return false;
  }
}
const ExperimentUtils$1 = new ExperimentUtils();
export {
  ExperimentUtils,
  ExperimentUtils$1 as default
};
//# sourceMappingURL=ExperimentUtils.js.map
